var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.925 10.984C11.5655 10.6562 11.3409 10.2063 11.295 9.72196V6.74796C11.3102 5.66025 10.9632 4.59837 10.3088 3.72942C9.65437 2.86047 8.7296 2.23378 7.68 1.94796C7.68 1.65834 7.56495 1.38059 7.36016 1.1758C7.15537 0.971007 6.87762 0.855957 6.588 0.855957C6.29838 0.855957 6.02063 0.971007 5.81584 1.1758C5.61105 1.38059 5.496 1.65834 5.496 1.94796C4.44659 2.23397 3.52204 2.86074 2.86781 3.72967C2.21358 4.5986 1.86679 5.66038 1.882 6.74796V9.72196C1.83608 10.2063 1.61149 10.6562 1.252 10.984L0 12.235V14.118H4.706C4.706 14.6172 4.90433 15.096 5.25737 15.4491C5.61041 15.8021 6.08923 16.0005 6.5885 16.0005C7.08777 16.0005 7.56659 15.8021 7.91963 15.4491C8.27267 15.096 8.471 14.6172 8.471 14.118H13.176V12.235L11.925 10.984Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.33fd197cb0834708c59fab5770025cb5.svg";
export { ForwardRef as ReactComponent };